import { useMutation } from '@tanstack/react-query';

import { redirectToSignIn } from '@/shared/api/redirect-to-sign-in';
import { clearEmailVerificationGateExemption } from '@/shared/lib/email-verification-gate-exemption';

import { useSignOutOptions } from '../api/user.mutations';

export function useAuth() {
    const signOutOptions = useSignOutOptions();
    const signOutMutation = useMutation(signOutOptions);

    const signIn = () => {
        redirectToSignIn(false);
    };

    const signOut = async () => {
        // Cleared up front rather than in onSuccess: a failed sign-out leaves the user in the app,
        // and a trial member's next beforeLoad simply re-grants it.
        clearEmailVerificationGateExemption();
        signOutMutation.mutate(undefined, {
            onSuccess: () => redirectToSignIn(false),
        });
    };

    return { signIn, signOut };
}
